module.exports = __webpack_public_path__ + "static/media/icn_review_edit.6568df1d.svg";